import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  submitIndeedFlexOtp,
  type SubmitIndeedFlexOtpParams,
} from 'api/admin/indeedFlex/submitIndeedFlexOtp'
import { indeedFlexKeys } from './keys'

export const useSubmitIndeedFlexOtpMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: SubmitIndeedFlexOtpParams) =>
      submitIndeedFlexOtp(params),
    onSuccess: async () =>
      queryClient.invalidateQueries({ queryKey: indeedFlexKeys.authStatus() }),
  })
}
